import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const ParallaxImage = ({ src, alt, className = "", imgClassName = "", speed = 0.15 }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${speed * 100}%`, `${speed * 100}%`]);

  return (
    <div ref={ref} className={`overflow-hidden ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        style={{ y, scale: 1 + speed * 2 }}
        className={`w-full h-full object-cover ${imgClassName}`}
        loading="lazy"
      />
    </div>
  );
};

export default ParallaxImage;
